export default "__VITE_ASSET__DcKh18uW__"